import { Client, Message, StompSubscription } from '@stomp/stompjs';
import {Observable, of} from 'rxjs';
import {MapByStr} from "../../models/common/Map";
import {ErrorAction, ReduxAction} from "../../models/common/ActionTypes";
import {ofType, StateObservable} from "redux-observable";
import {AppState} from "../../reducers/RootReducer";
import {catchError, mergeMap, switchMap} from "rxjs/operators";
import {APP_CONFIG} from "../../config/GeneralConfig";
import {ajax} from "rxjs/ajax";
import {eventNotificationError} from "../common/EventNotificationActions";
import {RouteMethods} from "../../config/RouteConfig";

export interface ChatMessage {
  id: number
  content: string
  sender: 'user' | 'ai'
  timestamp: Date,
  metadata: MapByStr<any>
}


/*
// Message interface for type safety


export const isProcessingKey = "isProcessing"

// Create a function to get a STOMP client
export const getChatWebSocket = (): Client => {
  const client = new Client({
    brokerURL: 'ws://gibcontrol.local:8443/api/ws',
    connectHeaders: {},
    debug: function (str) {
      console.log(str);
    },
    reconnectDelay: 5000,
    heartbeatIncoming: 4000,
    heartbeatOutgoing: 4000,
  });

  client.activate();
  return client;
};


// Function to send a message to the AI
export const sendMessage = (client: Client, message: string, userId: number): void => {
  if (client.connected) {
    client.publish({
      destination: '/app/chat.processRequest',
      body: JSON.stringify({
        id: userId,
        content: message,
        sender: 'user',
        timestamp: ( new Date()).getTime()
      })
    });
  } else {
    console.error('STOMP client is not connected');
  }
};


// Function to get messages from the AI
export const getMessages = (client: Client): Observable<ChatMessage> => {


  return new Observable<ChatMessage>(observer => {
    let subscription: StompSubscription;

    // Wait for connection to be established
    const connectCallback = () => {

      subscription = client.subscribe('/topic/responses', (message: Message) => {
        try {
          const chatMessage: ChatMessage = JSON.parse(message.body);
          observer.next(chatMessage);
        } catch (error) {
          observer.error(error);
        }
      });
    };

    if (client.connected) {
      connectCallback();
    } else {
      client.onConnect = connectCallback;
    }

    // Return cleanup function
    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  });
};
*/

export type AiActionTypes = AiSendUserMessageActionTypes
    | AiAddDocumentsToVectorStoreActionTypes


export interface AiSendUserMessageAction extends ReduxAction<typeof AI_SEND_USER_MESSAGE> {
  msg: ChatMessage
}
export interface AiSendUserMessageSuccessAction extends ReduxAction<typeof AI_SEND_USER_MESSAGE_SUCCESS> {
  msg: ChatMessage
}
export interface AiSendUserMessageErrorAction extends ErrorAction<typeof AI_SEND_USER_MESSAGE_ERROR> {

}

export type AiSendUserMessageActionTypes = AiSendUserMessageAction | AiSendUserMessageSuccessAction | AiSendUserMessageErrorAction

export const AI_SEND_USER_MESSAGE = "AI_SEND_USER_MESSAGE";
export const AI_SEND_USER_MESSAGE_SUCCESS = "AI_SEND_USER_MESSAGE_SUCCESS";
export const AI_SEND_USER_MESSAGE_ERROR = "AI_SEND_USER_MESSAGE_ERROR";

export function aiSendUserMessage( msg: ChatMessage ): AiSendUserMessageAction {
  return { type: AI_SEND_USER_MESSAGE, msg };
}

export function aiSendUserMessageSuccess( response: ChatMessage ): AiSendUserMessageSuccessAction {
  return { type: AI_SEND_USER_MESSAGE_SUCCESS, msg: response };
}

export function aiSendUserMessageError( error: any ): AiSendUserMessageErrorAction {
  return { type: AI_SEND_USER_MESSAGE_ERROR, error: error };
}

export function aiSendUserMessageEpic(
    action$: Observable< AiSendUserMessageAction >,
    store$: StateObservable<AppState>
) {

  return action$.pipe(
      ofType( AI_SEND_USER_MESSAGE ),
      switchMap( action => {
        const apiReq = APP_CONFIG.baseWeb + "ai/chat";

        return ajax(
            APP_CONFIG.getRequestObject(
                apiReq,
                RouteMethods.post,
                {
                  ...action.msg,
                  timestamp: action.msg.timestamp.getTime()
                }
            ) ).pipe(
            mergeMap( response => of(
                    aiSendUserMessageSuccess( response.response as ChatMessage )
                )
            ),
            catchError( error => of(
                eventNotificationError(
                    error,
                    store$,
                    'aiChat',
                    'aiSendUserMessage'
                )
            ) )
        );
      }
   )
  );
}

export interface AiAddDocumentsToVectorStoreAction extends ReduxAction<typeof AI_ADD_DOCS_TO_VECTOR_STORE> {
    files: File[]
}
export interface AiAddDocumentsToVectorStoreSuccessAction extends ReduxAction<typeof AI_ADD_DOCS_TO_VECTOR_STORE_SUCCESS> {

}
export interface AiAddDocumentsToVectorStoreErrorAction extends ErrorAction<typeof AI_ADD_DOCS_TO_VECTOR_STORE_ERROR> {

}

export type AiAddDocumentsToVectorStoreActionTypes = AiAddDocumentsToVectorStoreAction
    | AiAddDocumentsToVectorStoreSuccessAction
    | AiAddDocumentsToVectorStoreErrorAction;

export const AI_ADD_DOCS_TO_VECTOR_STORE = "AI_ADD_DOCS_TO_VECTOR_STORE";
export const AI_ADD_DOCS_TO_VECTOR_STORE_SUCCESS = "AI_ADD_DOCS_TO_VECTOR_STORE_SUCCESS";
export const AI_ADD_DOCS_TO_VECTOR_STORE_ERROR = "AI_ADD_DOCS_TO_VECTOR_STORE_ERROR";